if (!customElements.get('carousel-slider')) {
	customElements.define('carousel-slider', class CarouselSlider extends HTMLElement {
		constructor() {
			super();
		}

		connectedCallback() {
			this.carousel = this.querySelector('.grid-carousel');

			if (this.dataset.photoLightbox === 'true') {
				this.addEventListener('click', (event) => {
					const trigger = event.target.closest('.gag-work-lightbox-trigger');
					if (trigger) {
						const dialog = document.getElementById(trigger.dataset.lightboxDialog);
						if (!dialog) return;

						event.preventDefault();
						event.stopImmediatePropagation();
						if (typeof dialog.showModal === 'function') {
							dialog.showModal();
						} else {
							dialog.setAttribute('open', '');
						}
						return;
					}

					const navigationButton = event.target.closest('.gag-work-dialog-prev, .gag-work-dialog-next');
					if (navigationButton) {
						event.preventDefault();
						event.stopImmediatePropagation();
						const dialog = navigationButton.closest('dialog');
						const direction = navigationButton.classList.contains('gag-work-dialog-prev') ? -1 : 1;
						this.showAdjacentDialog(dialog, direction);
						return;
					}

					const closeButton = event.target.closest('.gag-work-dialog-close');
					if (closeButton) {
						event.preventDefault();
						event.stopImmediatePropagation();
						closeButton.closest('dialog').close();
						return;
					}

					if (event.target.matches('.gag-work-dialog')) {
						event.preventDefault();
						event.stopImmediatePropagation();
						event.target.close();
					}
				}, true);

				this.addEventListener('keydown', (event) => {
					const dialog = event.target.closest('.gag-work-dialog[open]');
					if (!dialog) return;

					if (event.key === 'Escape') {
						event.preventDefault();
						dialog.close();
					} else if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
						event.preventDefault();
						this.showAdjacentDialog(dialog, event.key === 'ArrowLeft' ? -1 : 1);
					}
				});

				this.addEventListener('pointerdown', (event) => {
					if (event.pointerType !== 'touch') return;
					if (!event.target.closest('.gag-work-dialog[open]')) return;
					this.lightboxTouchStartX = event.clientX;
				}, true);

				this.addEventListener('pointerup', (event) => {
					if (event.pointerType !== 'touch' || this.lightboxTouchStartX == null) return;
					const dialog = event.target.closest('.gag-work-dialog[open]');
					const distance = event.clientX - this.lightboxTouchStartX;
					this.lightboxTouchStartX = null;
					if (!dialog || Math.abs(distance) < 50) return;

					event.preventDefault();
					this.showAdjacentDialog(dialog, distance > 0 ? -1 : 1);
				}, true);
			}

			this.initialize();
		}

		showAdjacentDialog(dialog, direction) {
			const dialogs = Array.from(this.querySelectorAll('.gag-work-dialog'));
			const currentIndex = dialogs.indexOf(dialog);
			if (currentIndex === -1 || dialogs.length < 2) return;

			const nextIndex = (currentIndex + direction + dialogs.length) % dialogs.length;
			const nextDialog = dialogs[nextIndex];
			dialog.close();

			if (typeof nextDialog.showModal === 'function') {
				nextDialog.showModal();
			} else {
				nextDialog.setAttribute('open', '');
			}
		}

		initialize() {
			// Flickity doesn't work with flex containers, so
			// to avoid flash of unstyled content and page jump, style the container
			// as block just before initialization. On mobile where the carousel
			// is converted to simple scroller we swap this to display: flex !important
			// using CSS.
			this.carousel.style.display = 'block';
			this.flickity = new Flickity(this.carousel, {
				cellAlign: 'left',
				groupCells: true,
				contain: true,
				resize: true,
				draggable: this.dataset.photoLightbox !== 'true',
				prevNextButtons: false,
				fade: false,
				cellSelector: '.grid-item',
				initialIndex: 0,
				pageDots: false,
				wrapAround: false,
				accessibility: false,
				watchCSS: true,
			});

			this.flickity.on('change', (index) => {
				publish(PUB_SUB_EVENTS.sliderSlideChange, {
					id: this.getAttribute('id'),
					index,
				});
			});
		}
	});
}

if (!customElements.get('carousel-navigation')) {
	customElements.define('carousel-navigation', class CarouselNavigation extends HTMLElement {
		constructor() {
			super();
		}

		connectedCallback() {
			this.init();
		}

		init(retry = 1, maxRetry = 3) {
			if (retry === maxRetry) {
				return;
			}

			const id = this.getAttribute('for');
			this.carouselComponent = document.querySelector(`#${id}`);

			if ((!this.carouselComponent || !this.carouselComponent.flickity)) {
				setTimeout(() => {
					this.init(retry + 1);
				}, 350);
				return;
			}

			this.flickity = this.carouselComponent.flickity;
			this.buttonPrev = this.querySelector('.js-prev');
			this.buttonNext = this.querySelector('.js-next');

			this.buttonPrev.addEventListener('click', (event) => {
				event.preventDefault();
				this.flickity.previous();
			});

			this.buttonNext.addEventListener('click', (event) => {
				event.preventDefault();
				this.flickity.next();
			});

			this.flickity.on('select', () => {
				this.enableButton(this.buttonPrev);
				this.enableButton(this.buttonNext);

				if (!this.flickity.slides[this.flickity.selectedIndex - 1]) {
					this.disableButton(this.buttonPrev);
				} else if (!this.flickity.slides[this.flickity.selectedIndex + 1]) {
					this.disableButton(this.buttonNext);
				}
			});
		}

		enableButton(button) {
			button.classList.remove('pill-nav-item-disabled');
			button.classList.remove('focus-none');
			button.setAttribute('aria-disabled', 'false');
		}

		disableButton(button) {
			button.classList.add('pill-nav-item-disabled');
			button.classList.add('focus-none');
			button.setAttribute('aria-disabled', 'true');
		}
	});
}
